import { FunctionalComponent, h } from 'preact';
import { Route, route, Router } from 'preact-router';

import Home from '../routes/home';
import NotFoundPage from '../routes/notfound';
import Splash from '../routes/splash';
import { useEffect } from 'preact/hooks';
import { api } from '../services/APIService';
import { filter, first } from 'rxjs/operators';
import { createHashHistory } from 'history';

const App: FunctionalComponent = () => {
  useEffect(() => {
    route('/splash');
    api.auth
      .pipe(
        filter(value => value),
        first(),
      )
      .subscribe(() => route('/'));
    api.login();
  }, []);

  return (
    <div id='app'>
      <Router history={createHashHistory() as any}>
        <Route path='/splash' component={Splash} />
        <Route path='/' component={Home} />
        <NotFoundPage default />
      </Router>
    </div>
  );
};

export default App;
